import {baseSelector, useSliceDispatch} from "../../utils";
import {UserActions} from "./actions";
import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {useSelector} from "react-redux";
import {UserSliceState} from "./reducers";

export const useUserDispatch = () => useSliceDispatch<UserActions>();

export const selectUserSlice = createSelector(
    [
        (state: RootState) => state.user,
        (state: RootState, keys: (keyof UserSliceState)[]) => keys
    ],
    (slice, keys) => baseSelector(slice, keys)() // Call the baseSelector function here to get the selected props
);

export const useUserSelector = (keys: (keyof UserSliceState)[]) => {
    return useSelector((state: RootState) => selectUserSlice(state, keys));
}


